import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const LandscapeTurfPage = lazy(() => import('../pages/landscape-turf/page'));
const PetTurfPage = lazy(() => import('../pages/pet-turf/page'));
const AthleticTurfPage = lazy(() => import('../pages/athletic-turf/page'));
const PuttingGreenTurfPage = lazy(() => import('../pages/putting-green-turf/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/landscape-turf',
    element: <LandscapeTurfPage />,
  },
  {
    path: '/pet-turf',
    element: <PetTurfPage />,
  },
  {
    path: '/athletic-turf',
    element: <AthleticTurfPage />,
  },
  {
    path: '/putting-green-turf',
    element: <PuttingGreenTurfPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;